import { Box, Skeleton, Typography } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers-pro';
import { isSameDay, isBefore } from 'date-fns';

import { moods } from './utils';

import { CalendarDayProps } from './types';

import * as S from './styles';

export function CalendarDay({
  daysWithMoodTracker,
  day,
  selectedDay = new Date(),
  onDaySelect,
  isLoading = false,
  ...props
}: CalendarDayProps) {
  const isBeforeToday = isBefore(day, new Date());
  const isAfterToday = isBefore(new Date(), day);

  const isDayWithMoodTracker = daysWithMoodTracker?.find(eachDay => {
    if (isSameDay(new Date(eachDay.date), day)) {
      return eachDay;
    }

    return null;
  });

  return (
    <PickersDay
      day={day}
      {...props}
      showDaysOutsideCurrentMonth={false}
      disableHighlightToday
      disableRipple
      disableTouchRipple
      onDaySelect={onDaySelect}
      selected={selectedDay ? isSameDay(day, selectedDay) : false}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={1}
        my={1}
      >
        {isLoading && <Skeleton variant="circular" width={20} height={20} />}

        {!isLoading && (
          <>
            <Typography variant="body2" color="textSecondary">
              {day.getDate()}
            </Typography>

            {isDayWithMoodTracker && <>{moods[isDayWithMoodTracker.mood]}</>}

            {!isDayWithMoodTracker && isBeforeToday && <S.PastDayIcon />}

            {!isDayWithMoodTracker && isAfterToday && <S.FutureDayIcon />}
          </>
        )}
      </Box>
    </PickersDay>
  );
}
